import { render, staticRenderFns } from "./examroomseat.vue?vue&type=template&id=c2858992&scoped=true&"
import script from "./examroomseat.vue?vue&type=script&lang=js&"
export * from "./examroomseat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2858992",
  null
  
)

export default component.exports